import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const NewsSection = styled.div.attrs({ className: "flex min-w-0 items-start gap-3" })``;

export const NewsContentStack = styled.div.attrs({ className: "min-w-0" })``;

export const NewsPreviewImage = styled(FallbackImage).attrs({
  className: "h-16 w-16 shrink-0 rounded-2xl",
})``;

export const NewsLabelText = styled.p.attrs({ className: "font-medium text-[var(--brand-ink)]" })``;

export const NewsMetaText = styled.p.attrs({
  className: "mt-1 text-xs text-[var(--brand-muted)]",
})``;

export const NewsGridLayout = styled.div.attrs({
  className: "grid gap-3 md:grid-cols-[1.4fr_0.8fr]",
})``;

export const NewsFieldInput = styled.input.attrs({ className: "brand-input" })``;

export const NewsFieldSelect = styled.select.attrs({ className: "brand-input" })``;
